
import React from 'react';
import { FacilityOrderNewFlowConfirmModalTemplate } from 'themes/application/facility-order-new-flow/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderNewFlowConfirmModalStore } from 'application/facility-order-new-flow/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowConfirmModalStore(rootStore, componentProps), 'facilityOrderNewFlowConfirmModalStore')
@observer
class FacilityOrderNewFlowConfirmModal extends React.Component {
    render() {
        return <FacilityOrderNewFlowConfirmModalTemplate {...this.props} />
    }
}

export default FacilityOrderNewFlowConfirmModal;
